<template>
  <div class="vote-model-container" v-if="sourceData" :class="{ 'is-vote': is_vote_or_end }" contenteditable="false">
    <div class="vote-title" contenteditable="false">
      <svg width="17px" height="14px" viewBox="0 0 17 14">
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="投票优化-投票前" transform="translate(-566.000000, -449.000000)">
            <g id="编组-10" transform="translate(550.000000, 424.000000)">
              <g id="编组-61" transform="translate(16.000000, 20.000000)">
                <g id="vote" transform="translate(0.000000, 5.000000)">
                  <path
                    d="M14.3333333,0.75 C14.6785113,0.75 14.9910113,0.889911016 15.2172168,1.11611652 C15.4434223,1.34232203 15.5833333,1.65482203 15.5833333,2 L15.5833333,2 L15.5833333,9.66666667 C15.5833333,10.0118446 15.4434223,10.3243446 15.2172168,10.5505501 C14.9910113,10.7767557 14.6785113,10.9166667 14.3333333,10.9166667 L14.3333333,10.9166667 L3.68432819,10.9166667 L0.75,12.6758892 L0.75,2 C0.75,1.65482203 0.889911016,1.34232203 1.11611652,1.11611652 C1.34232203,0.889911016 1.65482203,0.75 2,0.75 L2,0.75 L14.3333333,0.75 Z"
                    id="Rectangle"
                    stroke="#393D40"
                    stroke-width="1.5"
                  ></path>
                  <g id="Group-7" transform="translate(3.888889, 2.333333)" fill="#393D40">
                    <rect id="Rectangle" x="3.11111111" y="0" width="1.55555556" height="7"></rect>
                    <rect id="Rectangle" x="6.22222222" y="1.55555556" width="1.55555556" height="5.44444444"></rect>
                    <rect id="Rectangle" x="0" y="3.11111111" width="1.55555556" height="3.88888889"></rect>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <span>{{ sourceData.title }}</span>
      <span class="vote-multiple" v-if="sourceData.type !== 1">（最多可选{{ sourceData.max_options_num }}项）</span>
    </div>
    <div class="vote-info" contenteditable="false">
      <span class="vote-people" v-if="is_vote_or_end">
        <span style="color: #FF5144;">{{ sourceData.people_num }}人</span>
        参与
      </span>
      <span class="vote-expire-time">{{ dayjs(sourceData.end_at * 1000).format("YYYY-MM-DD HH:mm:ss") }} 截止</span>
    </div>
    <div class="vote-desc" contenteditable="false">{{ sourceData.desc }}</div>
    <div class="vote-options" contenteditable="false">
      <div
        class="vote-options-item"
        v-for="(item, index) in sourceData.options"
        :key="index"
        :class="{ active: item.is_selected }"
      >
        <div
          class="percentage"
          v-if="is_vote_or_end"
          :style="{ width: `${parseInt((item.vote_num / (total_vote_num || 1)) * 100)}%` }"
        ></div>
        <label :role="inputType" :class="{ 'is-checked': item.is_selected }">
          <img v-if="item.image" :src="item.image" loading="lazy" class="lazy-img preview-image" />
          <span>{{ item.name }}</span>
          <span :class="inputClass" v-if="!is_vote_or_end">
            <input
              :type="inputType"
              :name="`vote-input-${item.id}`"
              :checked="item.is_selected"
              @change="() => handleSelect(item)"
            />
            <i class="wiki-icon wiki-icon-success-checked"></i>
          </span>
          <span class="result" v-else>
            <span class="vote-num">{{ item.vote_num }}票</span>
            <span class="percentage-num">{{ parseInt((item.vote_num / (total_vote_num || 1)) * 100) }}%</span>
          </span>
        </label>
      </div>
    </div>

    <div class="btn-group" v-if="!is_vote_or_end">
      <button
        class="vote-submit-btn"
        :class="{ disable: sourceData && sourceData.options.filter(item => item.is_selected).length === 0 }"
        @click="handleVote"
      >
        投票
      </button>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { apiContentVote } from "@/api/contentApi";
export default {
  name: "VoteRender",
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      sourceData: null
    };
  },
  computed: {
    inputType() {
      return this.data.type === 1 ? "radio" : "checkbox";
    },
    inputClass() {
      return this.data.type === 1 ? "input-radio" : "input-checked";
    },
    is_vote_or_end() {
      return this.sourceData.is_vote || this.sourceData.is_end;
    },
    total_vote_num() {
      return this.is_vote_or_end ? this.sourceData.options.reduce((acc, cur) => acc + cur.vote_num, 0) : 0;
    }
  },
  watch: {
    data: {
      handler(val) {
        if (val) {
          this.sourceData = val;
        }
      },
      immediate: true
    }
  },
  methods: {
    dayjs,
    handleSelect(item) {
      if (this.data.type === 1) {
        const data = this.sourceData;
        data.options.forEach(it => {
          if (it.id === item.id) {
            it.is_selected = true;
          } else {
            it.is_selected = false;
          }
        });
        this.sourceData = JSON.parse(JSON.stringify(data));
      } else {
        const data = this.sourceData;
        data.options.forEach(it => {
          if (it.id === item.id) {
            it.is_selected = !it.is_selected;
          }
        });
        let selectedLength = data.options.filter(item => item.is_selected).length;
        if (selectedLength > this.data.max_options_num) {
          data.options.forEach(it => {
            if (it.id === item.id) {
              it.is_selected = false;
            }
          });
          this.$message.warning(`最多可选${this.data.max_options_num}项`);
          this.sourceData = JSON.parse(JSON.stringify(data));
        } else {
          this.sourceData = JSON.parse(JSON.stringify(data));
        }
      }
    },
    handleVote() {
      if (!this.isLoginShow("登录后可投票")) return;
      const { id: detailId } = this.$route.params;
      const params = {
        content_id: Number(detailId),
        vote_id: this.sourceData.id,
        options: this.sourceData.options.filter(it => it.is_selected).map(it => ({ id: Number(it.id) }))
      };
      console.log(params);
      apiContentVote(params)
        .then(res => {
          if (res && res.code == 0) {
            this.$message.success("投票成功");

            this.is_vote_or_end = true;
            const data = this.sourceData;
            data.people_num += 1;
            data.is_vote = true;
            data.options.forEach(item => {
              if (item.is_selected) {
                item.vote_num += 1;
              }
            });
            this.sourceData = JSON.parse(JSON.stringify(data));
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="less">
.vote-model-container {
  background: #f9f9f9;
  padding: 20px 16px;
  border-radius: 8px;
  &.is-vote {
    .input-radio,
    .input-checked {
      display: none;
    }
  }

  .vote-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    margin-bottom: 4px;
    svg {
      margin-right: 7px;
      margin-top: 3px;
    }
  }

  .vote-info {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 17px;
    margin-bottom: 10px;

    .vote-people {
      margin-right: 20px;
    }
  }

  .vote-desc {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    line-height: 20px;
    margin-bottom: 16px;
  }

  .vote-multiple {
    font-size: 16px;
    color: #999;
  }

  .vote-options {
    .vote-options-item {
      position: relative;
      height: 52px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 6px;
      padding: 0px 16px;
      margin-bottom: 8px;
      border: 1px solid #f0f0f0;

      &.active {
        .input-radio,
        .input-checked {
          display: inline-block;
        }

        .percentage {
          &::after {
            background: #d2f4ff;
          }
        }

        .result {
          color: #333333;
        }
      }

      .percentage {
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        border-radius: 6px;
        overflow: hidden;

        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 6px 0px 0px 6px;
          background: #e4e7ec;
          animation-name: progressAnimation;
          // animation-duration: 0.3s;
        }

        @keyframes progressAnimation {
          from {
            width: 0;
          }

          to {
            width: 100%;
          }
        }
      }

      label {
        display: flex;
        align-items: center;
        width: 100%;
        height: 52px;
        position: relative;
        // z-index: 10;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        padding-right: 120px;
        cursor: pointer;

        &.is-checked {
          .input-radio,
          .input-checked {
            border: 1px solid #65bf52;
            background-color: #65bf52;

            i {
              display: inline-block;
            }
          }
        }

        .result {
          position: absolute;
          right: 0;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          line-height: 20px;

          .vote-num {
            vertical-align: middle;
          }
          .percentage-num {
            display: inline-block;
            margin-left: 16px;
            min-width: 40px;
            vertical-align: middle;
            text-align: right;
          }
        }

        img {
          width: 44px;
          height: 44px;
          border-radius: 6px;
          vertical-align: middle;
          margin-right: 16px;
          margin-left: -3px;
        }

        .input-radio,
        .input-checked {
          flex-shrink: 0;
          margin-left: 16px;
          position: absolute;
          right: 0;
        }
      }
    }
  }

  .input-radio {
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #d8d8d8;
    background: #d8d8d8;
    transition: border-width ease-in 0.2s;

    i {
      width: 16px;
      height: 16px;
      display: none;
    }

    input {
      display: none;
      width: 100%;
      height: 100%;
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
      color: inherit;
    }
  }

  .input-checked {
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #d8d8d8;
    background: #d8d8d8;
    transition: border-width ease-in 0.2s;

    i {
      width: 16px;
      height: 16px;
      display: none;
    }

    input {
      display: none;
      width: 100%;
      height: 100%;
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
      color: inherit;
    }
  }

  .btn-group {
    text-align: right;
    padding: 10px 10px 0;

    button {
      width: 72px;
      height: 34px;
      background: #00afe8;
      border-radius: 4px;
      border: 1px solid #ddf3ff;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;

      &.disable {
        background: #d2d2d2;
        border: 1px solid #d2d2d2;
        cursor: not-allowed;
        pointer-events: none;
      }
    }
  }
}
</style>
